import React from "react";
import { ProjectData } from "../../interfaces/TaskDetails";
import { Box } from "@mui/material";
import DocumentDownloadLink from "./DocumentDownloadLink";

export type IDocumentCardProps = {
  projectData: ProjectData | null;
};

const DocumentCard: React.FC<IDocumentCardProps> = ({ projectData }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        width: "90%",
        mt: "25px",
      }}
    >
      <DocumentDownloadLink
        documentUrl={projectData?.safety_card_link ?? ""}
        projectId={projectData?.project_id ?? null}
        documentName="VGM.pdf"
      >
        VGM
      </DocumentDownloadLink>
      <DocumentDownloadLink
        documentUrl={projectData?.lmra_link ?? ""}
        projectId={projectData?.project_id ?? null}
        documentName="LMRA"
      >
        LMRA
      </DocumentDownloadLink>
      <DocumentDownloadLink
        documentUrl={projectData?.ewp_link ?? ""}
        projectId={projectData?.project_id ?? null}
        documentName="EWP"
      >
        EWP
      </DocumentDownloadLink>
    </Box>
  );
};

export { DocumentCard };
